import React from "react";
import blogImage from "../../images/blogImage.png";
import sectionMaskGroup from "../../images/Logos.png";
import pehar from "../../images/pehar.png"
import sectionMaskGroupMobile from "../../images/Logos-3.png";
import play from "../../images/Demo.png"
import about from "../../images/Rekoa za nas.png"
import TestimonialCarousel from "../../components/TestimonialCarousel";
import { useNavigate } from "react-router-dom";

const About: React.FC = () => {
  const testimonials = [
  {
    text: "Автоматизирањето на патните листи ни заштедува многу време во процесот на припрема на турите. Знаејќи дека овие информации ни се точни и брзо достапни, ние можеме да посветиме повеќе време на организирање на патувањето наместо организирање на документација.",
    author: "Боре Спасеновски",
    role: "Туристичка агенција Скаут",
  },
  {
    text: "Субагентите многу побрзо и полесно ги продаваат нашите соби. Телефонските проверки и ризикот од непродадените соби се минато! Сега сме на располагање на нашите субагенти 24/7.",
    author: "Борис Вчков",
    role: "Туристичка агенција ТравелX",
  },
  {
    text: "Merakzy ни помага во автоматизирање на целосната документација за една резервација. Сега имаме повеќе време да посветиме на клиентите, наместо на креирање на документите.",
    author: "Александар Чоневски",
    role: "Туристичка агенција Игуана",
  },
];

  const navigate = useNavigate();

  const handleNavigateToContact = () => {
    navigate('/contact');
  }

  return (
    <div className="bg-white">
      <section className="text-center pt-24 px-4 md:px-6">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-6xl font-semibold leading-tight mb-6">
            <span className="text-[#0c0407]">За нас</span>
          </h1>
          <p className="text-lg md:text-xl text-[#0c0407] max-w-4xl mx-auto my-10">
            Merakzy е првиот веб-базиран софтвер за туристичко работење, способен целосно да ги автоматизира и поедностави операциите на туристичките агенции.
          </p>
        </div>
      </section>

      <section className="relative w-full pb-12 pt-6 px-4 md:px-6">
        <div className="container mx-auto">
          <div className="relative w-full h-[20rem] md:h-[30rem] rounded-3xl overflow-hidden">
            <img
              src={blogImage}
              alt="Brochure"
              className="w-full h-full object-contain rounded-3xl"
            />
          </div>
        </div>
      </section>

      <section className="pb-16 pt-6 border-b border-gray-200 px-4 md:px-6">
        <div className="container mx-auto">
            <p className="text-black-400 font-bold mb-6 text-center">
            ВЕРЕН ПАРТНЕР НА ПОВЕЌЕ ОД 20 КОМПАНИИ ВО МАКЕДОНИЈА И СРБИЈА
            </p>

            {/* Mobile carousel */}
            <div className="relative w-full h-24 md:hidden overflow-hidden">
            {/* Fade overlay */}
            <div className="pointer-events-none absolute inset-0 z-10 flex">
              <div className="w-16 h-full bg-gradient-to-r from-white"></div>
              <div className="flex-1"></div>
              <div className="w-16 h-full bg-gradient-to-l from-white"></div>
            </div>

            {/* Scrolling images */}
            <div className="flex w-[200%] absolute top-0 left-0 animate-scroll-horizontal">
              <img
                src={sectionMaskGroupMobile}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
              <img
                src={sectionMaskGroupMobile}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
            </div>
          </div>

            {/* Desktop carousel */}
            <div className="relative w-full h-24 hidden md:block overflow-hidden">
            {/* Fade overlay */}
            <div className="pointer-events-none absolute inset-0 z-10 flex">
              <div className="w-16 h-full bg-gradient-to-r from-white"></div>
              <div className="flex-1"></div>
              <div className="w-16 h-full bg-gradient-to-l from-white"></div>
            </div>

            {/* Scrolling images */}
            <div className="flex w-[200%] absolute top-0 left-0 animate-scroll-horizontal">
              <img
                src={sectionMaskGroup}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
              <img
                src={sectionMaskGroup}
                alt="Partner logos"
                className="h-full w-1/2 flex-shrink-0"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 px-4 sm:px-6 lg:px-24 xl:px-32 max-w-[76rem] mx-auto">
        <div className="container mx-auto">
          
          {/* Top content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            
            {/* Left text */}
            <div className="lg:col-span-2">
              <p className="text-[#0c0407] mb-6 leading-relaxed">
                Нашата приказна започна во 2012 година со првиот систем за онлајн
                резервации „Ајде на Одмор“, кој подоцна прерасна во MBooking.
                Во 2018 година го лансиравме Merakzy како модерна и скалабилна
                платформа создадена според реалните потреби на туристичките агенции
                во регионот.
              </p>

              <p className="text-[#0c0407] mb-6 leading-relaxed">
                Покрај оптимизација на внатрешните процеси, Merakzy нуди и агрегатор
                на патувања во реално време што им овозможува на патниците брзо
                пребарување, споредба и директна резервација на понуди.
              </p>

              <p className="text-[#0c0407] mb-8 leading-relaxed">
                Постојано инвестираме во развој и иновации, со поддршка од меѓународни
                партнери и институции, за да им помогнеме на агенциите да работат
                поефикасно и попаметно. Merakzy е алатката што ја носи вашата
                туристичка агенција чекор напред.
              </p>

              <button className="bg-[#fa0053] text-white px-8 py-3 rounded-[16px] hover:opacity-90 transition" onClick={handleNavigateToContact}>
                Контактирајте нè
              </button>
            </div>

            {/* Right award card */}
            <div className="flex justify-center lg:justify-end">
              <div className="bg-gray-50 rounded-3xl p-8 text-center max-w-sm w-full">
                <img
                  src={pehar}
                  alt="Award"
                  className="mx-auto mb-6 max-h-64 object-contain"
                />
                <p className="text-sm text-[#0C0407] font-semibold">
                  Најдобар софтвер за
                  <br />
                  унапредување на туризмот
                </p>
                <p className="text-xs text-[#0C0407] mt-1">
                  Сајам Туризма 2025<br />
                  Нови Сад, Србија
                </p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 text-center">
            <div>
              <p className="text-5xl font-bold text-[#0C0407]">15+</p>
              <p className="text-sm text-[#0C0407] mt-2">
                Корисници од<br />Македонија и Србија
              </p>
            </div>

            <div>
              <p className="text-5xl font-bold text-[#0C0407]">10+</p>
              <p className="text-sm text-[#0C0407] mt-2">
                Години искуство<br />во туризмот
              </p>
            </div>

            <div>
              <p className="text-5xl font-bold text-[#0C0407]">100%</p>
              <p className="text-sm text-[#0C0407] mt-2">
                Задоволни<br />клиенти
              </p>
            </div>

            <div>
              <p className="text-5xl font-bold text-[#0C0407]">24/7</p>
              <p className="text-sm text-[#0C0407] mt-2">
                Корисничка<br />поддршка
              </p>
            </div>
          </div>

        </div>
      </section>

      <section className="relative bg-[#FA0053] py-12 md:py-24 px-4">
        <div className="container mx-auto">
          <div className="flex flex-col items-center text-center max-w-4xl mx-auto">

            {/* Demo label */}
            <div className="flex items-center gap-2 mb-6">
              <div className="w-6 h-6 flex items-center justify-center rounded-full">
                <img src={play} alt="Demo icon" className="w-6 h-6" />
              </div>
              <span className="text-sm text-white tracking-wide">
                ДЕМО
              </span>
            </div>

            {/* Heading */}
            <h2 className="text-3xl md:text-5xl font-semibold text-white mb-6 leading-tight">
              Пробајте го Merakzy бесплатно!
            </h2>

            {/* CTA Button */}
            <button className="bg-[#B6003C] text-white px-8 py-3 rounded-[16px] hover:opacity-90 transition" onClick={handleNavigateToContact}>
              Побарајте демо
            </button>

          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-6 bg-white">
        <div className="container mx-auto text-center max-w-4xl">

          {/* Label */}
            <div className="flex items-center md:justify-center gap-2 mb-6">
              <div className="w-6 h-6 flex items-center justify-center rounded-full">
                <img src={about} alt="" className="w-6 h-6" />
              </div>
              <span className="font-semibold text-sm">РЕКОА ЗА НАС</span>
            </div>

          {/* Title */}
          <h2 className="text-3xl md:text-5xl font-semibold text-[#0c0407] mb-12">
            Искуства од прва рака
          </h2>

          {/* Carousel */}
          <TestimonialCarousel testimonials={testimonials} />

        </div>
      </section>
    </div>
  )
};

export default About;







